import React from 'react'
import { AppCardTitle, AppDataTable, AppResultsSkeleton, NoDataFound } from '@components'
import { useRunningScrapersTable } from '../@hooks'
import { numSearchesColumn, numSearchesDoneColumn, siteColumn, actionsColumn } from './@columns'

export default function RunningScrapersTable() {

    const { tableData, isLoading } = useRunningScrapersTable()

    if (isLoading) return <AppResultsSkeleton/>
    if (!isLoading && !tableData.length) return <NoDataFound />

    return <AppDataTable
        title={<AppCardTitle icon="spider" title="Batch Scraper Searches"/>}
        data={tableData}
        columns={[siteColumn(), numSearchesColumn(), numSearchesDoneColumn(), actionsColumn()]}
    />
}